import React from "react";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import { Phone, Person, Store } from "@mui/icons-material";

interface FranchiseeContactCardProps {
    franchise?: {
        id: number;
        location: string;
        owner?: string;
        phone?: string;
        email?: string;
    };
}

const FranchiseeContactCard: React.FC<FranchiseeContactCardProps> = ({ franchise }) => {
    if (!franchise) return null;

    const hasContactInfo = franchise.owner || franchise.phone || franchise.email;
    if (!hasContactInfo) return null;

    return (
        <Box
            sx={{
                mb: '10px',
                p: 1.5,
                border: '1px solid',
                borderColor: 'primary.300',
                borderRadius: 'sm',
                backgroundColor: 'primary.50',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <Store sx={{ fontSize: 18, color: 'primary.600' }} />
                <Typography level="title-sm" sx={{ color: 'primary.700' }}>
                    Franchisee Contact — {franchise.location}
                </Typography>
            </Box>
            <Typography level="body-xs" sx={{ mb: 1, color: 'neutral.600' }}>
                Need help or have a question about pricing? Contact the franchisee directly.
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                {franchise.owner && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Person sx={{ fontSize: 16, color: 'neutral.500' }} />
                        <Typography level="body-sm">{franchise.owner}</Typography>
                    </Box>
                )}
                {franchise.phone && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Phone sx={{ fontSize: 16, color: 'neutral.500' }} />
                        <Typography
                            level="body-sm"
                            component="a"
                            href={`tel:${franchise.phone}`}
                            sx={{ color: 'primary.600', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                        >
                            {franchise.phone}
                        </Typography>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default FranchiseeContactCard;
